import type { AppRole } from "@asap/shared/utils/supabase.enum";

export function isTeamMember(roles: AppRole[]) {
  return roles.includes("team_member");
}

export function hasOnlyTeamMemberRole(roles: AppRole[]) {
  return roles.length === 1 && roles.includes("team_member");
}
